// extracted by css-extract-rspack-plugin
export default {"container":"_b2f4581"};